import { WHY_CHOOSE_US_POINTS } from "@/constants/whyChooseUs";

export const WhyChooseUsList = () => {
  return (
    <section data-testid="why-choose-us-list" className="bg-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16 sm:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {WHY_CHOOSE_US_POINTS.map(({ title, content, testId, icon: Icon }) => (
            <div key={testId} data-testid={testId} className="flex gap-4 rounded-xl border border-[#E2E8F0] p-6">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[#0B4F37]/10 text-[#0B4F37]">
                <Icon className="h-5 w-5" strokeWidth={1.8} />
              </span>
              <div>
                <h2 data-testid={`${testId}-title`} className="font-heading text-lg font-semibold text-[#042D1F] mb-1.5">
                  {title}
                </h2>
                <p data-testid={`${testId}-content`} className="text-sm sm:text-base text-slate-600 leading-relaxed">
                  {content}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
